var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.554,
    height: 21.204,
    viewBox: "0 0 18.554 21.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(-468.696 -664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(468.696 664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M20.654,0h11.26l5.968,5.945V19.879A1.325,1.325,0,0,1,36.558,21.2h-15.9a1.325,1.325,0,0,1-1.325-1.325V1.325A1.325,1.325,0,0,1,20.654,0Z",
    transform: "translate(-19.329)",
    fill: "#e2574c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M208.9,6.143h-4.619a1.326,1.326,0,0,1-1.325-1.325V.193Z",
    transform: "translate(-190.367 -0.18)",
    fill: "#b53629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M96.016,136.183a.385.385,0,0,0,0-.763H94.751a.4.4,0,0,0-.385.431v3.107c0,.277.158.431.371.431s.37-.154.37-.431v-.853h.765a.359.359,0,0,0,.356-.387.352.352,0,0,0-.356-.376h-.765v-1.159Zm-4.273-.763h-.925a.409.409,0,0,0-.429.428v3.112a.408.408,0,0,0,.44.417H91.8a1.8,1.8,0,0,0,1.908-1.923A1.848,1.848,0,0,0,91.742,135.42Zm.044,3.19h-.564v-2.423h.508c.769,0,1.1.516,1.1,1.229C92.835,138.083,92.506,138.61,91.787,138.61ZM88.4,135.42h-.916a.385.385,0,0,0-.4.431v3.107a.39.39,0,1,0,.777,0v-.907h.574a1.255,1.255,0,0,0,1.294-1.31A1.269,1.269,0,0,0,88.4,135.42Zm-.015,1.9h-.528V136.15h.528a.589.589,0,0,1,0,1.172Z",
    transform: "translate(-82.433 -126.135)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFileIcon);
export default __webpack_public_path__ + "static/media/document-file-icon.3f8020b66e07ffd5da5de8e97a76ee29.svg";
export { ForwardRef as ReactComponent };